import React, { useRef, useEffect } from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import { FieldInputProps } from 'react-final-form';
import { useSpeechRecognition } from '../hooks/useSpeechRecognition';

interface SpeechTextFieldProps extends Omit<TextFieldProps, 'input'> {
  input: FieldInputProps<any, HTMLElement>;
}

export const SpeechTextField: React.FC<SpeechTextFieldProps> = ({ input, ...props }) => {
  const valueRef = useRef(input.value);

  // Update the ref whenever input.value changes
  useEffect(() => {
    valueRef.current = input.value;
  }, [input.value]);

  const { listening, startSpeechRecognition, stopSpeechRecognition } = useSpeechRecognition(
    (transcript) => {
      const currentValue = valueRef.current || '';
      input.onChange(currentValue ? currentValue + ' ' + transcript : transcript);
    }
  );

  return (
    <TextField
      {...input as any}
      {...props}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            {!listening ? (
              <IconButton onClick={startSpeechRecognition}>
                <MicOffIcon />
              </IconButton>
            ) : (
              <IconButton onClick={stopSpeechRecognition}>
                <MicIcon />                
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};
